import { render, staticRenderFns } from "./FormLab.vue?vue&type=template&id=648823a8&"
import script from "./FormLab.vue?vue&type=script&lang=js&"
export * from "./FormLab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports